<template>
  <aha-badge
    :class="classes"
    :size="size"
    :label="label"
  />
</template>

<script>
import AhaBadge from './Badge.vue'

export default {
  components: {
    AhaBadge,
  },
  props: {
    label: {
      type: String,
      default: null,
    },
    size: {
      type: String,
      default: 'md',
    },
  },
  computed: {
    classes() {
      const baseClass = 'aha-pill-badge'
      let customClass = 'bg-secondary-40'
      if (this.label === 'admin' || this.label === 'pending') {
        customClass = 'bg-brand-a100'
      }

      return `${baseClass} ${customClass}`
    },
  },
}
</script>

<style lang="scss" scoped>
    .aha-pill-badge {
        @apply capitalize;
    }
</style>
